import React, { useState, useContext } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import '../styles/AuthPage.css';

const RegisterPage = () => {
  const { register } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const redirect = new URLSearchParams(location.search).get('redirect') || '/';
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    profileName: ''
  });
  const [error, setError] = useState('');
  const [consent, setConsent] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!consent) {
      setError('Bitte stimmen Sie der Datenschutzerklärung zu, um fortzufahren');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError('Passwörter stimmen nicht überein');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/;
    if (!passwordRegex.test(formData.password)) {
      setError('Passwort muss mindestens 8 Zeichen lang sein und Grossbuchstaben, Kleinbuchstaben, Zahlen und Sonderzeichen enthalten');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    setSubmitLoading(true);
    try {
      const { confirmPassword, ...userData } = formData;
      await register(userData);
      navigate(redirect);
    } catch (error) {
      setError(error.response?.data?.message || 'Registrierung fehlgeschlagen');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <h1>Account erstellen</h1>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>E-Mail *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>
              Passwort *
              <span className="info-tooltip" tabIndex={0}>
                <span className="info-icon">i</span>
                <span className="info-text">Mindestens 8 Zeichen, Gross- und Kleinbuchstaben, Zahlen und Sonderzeichen</span>
              </span>
            </label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              minLength="8"
            />
          </div>

          <div className="form-group">
            <label>Passwort bestätigen *</label>
            <input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>
              Anzeigename *
              <span className="info-tooltip" tabIndex={0}>
                <span className="info-icon">i</span>
                <span className="info-text">Wird öffentlich angezeigt, Gross- und Kleinschreibung sowie Leerzeichen erlaubt</span>
              </span>
            </label>
            <input
              type="text"
              name="profileName"
              value={formData.profileName}
              onChange={handleChange}
              placeholder="z.B. Max Muster"
              required
            />
          </div>

          <div className="form-group consent-group">
            <label className="consent-label">
              <input
                type="checkbox"
                checked={consent}
                onChange={(e) => setConsent(e.target.checked)}
                required
              />
              <span>
                Ich habe die{' '}
                <Link to="/datenschutz" target="_blank" rel="noopener noreferrer">
                  Datenschutzerklärung
                </Link>{' '}
                gelesen und stimme der Bearbeitung meiner Personendaten zu. *
              </span>
            </label>
          </div>

          <button type="submit" className="btn btn-primary" disabled={submitLoading}>
            {submitLoading ? 'Wird registriert…' : 'Registrieren'}
          </button>
        </form>

        <p className="auth-link">
          Bereits ein Konto? <Link to="/login">Anmelden</Link>
        </p>
      </div>
    </div>
  );
};

export default RegisterPage;
